import { graphql } from 'gatsby';
import React from 'react';
import parser from 'html-react-parser';
//
import './authorLine.scss';

interface Props {
  text: string;
}

const AuthorLine: React.FC<Props> = (props) => {
  return (
    <div className="author-line">
      <div className="author-line__wrapper">
        <div className="author-line__text">{parser(props.text)}</div>
      </div>
    </div>
  );
};

export default AuthorLine;

export const query = graphql`
  fragment AuthorLineBlock on WpAcfAuthorlineBlock {
    AcfAuthorLine {
      text
    }
  }
`;
